import { Link, useLocation } from "react-router-dom";

import { ListItem, ListItemIcon, ListItemText, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

import { Register, RouteItem } from "../RoutesConfig";
import useUserContext from "../../hooks/useUserContext";
import { PermissionType } from "../../common/interfaces/enums/PermissionType";

const style = (theme: Theme, extraStyles?: SxProps): SxProps => {
  return {
    ...extraStyles,
    backgroundColor: theme.palette.secondary.main + " !important",
    color: theme.palette.common.white,
  };
};

type ListItemExtendedProps = {
  routeItem?: RouteItem;
  register?: Register;
  extraStyles?: SxProps;
  exact?: boolean;
};

export default function ListItemExtended({ routeItem, register, extraStyles, exact, ...rest }: ListItemExtendedProps) {
  const location = useLocation();
  const { hasPermissions } = useUserContext();

  const to = register?.Root.Path ?? routeItem?.Path ?? "";
  const icon = register?.Root.Icon ?? routeItem?.Icon;
  const name = register?.Root.Label ?? routeItem?.Label;

  const match = exact ? location.pathname === to : location.pathname.startsWith(to);

  const render = () => {
    return (
      <ListItem
        sx={(theme) => ({ ...(match ? style(theme, extraStyles) : extraStyles) })}
        button
        component={Link}
        to={to}
        {...rest}
      >
        <ListItemIcon sx={{ ...(match ? { color: "white" } : undefined) }}>{icon}</ListItemIcon>
        <ListItemText primary={name} />
      </ListItem>
    );
  };

  return hasPermissions(register, PermissionType.Read, routeItem?.UserTypes) ? render() : null;
}
